
<div class="imageSelectionDiv">
  <v-icon @click="openPreview" class="viewIcon" color="white" v-show="imageLoaded">
    visibility
  </v-icon>
  <ImagePreview :image="image"
                :filter="filter"
                :favorite-editable="favoriteEditable"
                :show-favorite-icon="showFavoriteIcon"
                :small-height="smallHeight"
                :small-width="smallWidth"
                @select_image="onSelect()"
                @small-loaded="imageLoaded = true"
                class="imagePreview"
                doNotOpenOnClick
                ref="imagePreview"
  />
</div>
